import React from 'react'
import { v4 as uuidv4 } from 'uuid';


const SingleEducation = (element) =>{
    return(
        <div className="education mt-10">
            <p className="title-text">{element.degree}</p>
            <p className="subtitle-text">{element.college}{(element.college !== '' && element.city !== '') && ','}{element.city}</p>
            <div className="flex-container">
                <p className="italicstyling">{element.startDate} {element.endDate !== '' && '- '+element.endDate}</p>
                <p className="italicstyling">{element.grade}</p>
            </div>
            <p className="italicstyling">{element.descHead}</p>
            <p className="para-text">{element.desc}</p>
        </div>
    )
}

function Education(props) {
    return (
        <>
            <div>
                <p className="heading-text">EDUCATION</p>
                {
                    props.education.map(element => {
                        return <SingleEducation key={uuidv4()} {...element}/>
                    })
                }
            </div>
        </>
    )
}

export default Education
